// extracted by mini-css-extract-plugin
export default {"resourceBox":"relatedResource_resourceBox__NgmlP"};